var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { flushSync } from 'react-dom';
import { useTheme } from './theme-provider';
import { Sun, Moon } from 'lucide-react';
import { cn } from '../../lib/utils.js';
var sizeMap = {
    sm: 'h-8 w-8',
    md: 'h-9 w-9',
    lg: 'h-10 w-10',
};
var iconSizeMap = {
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6',
};
export function ThemeToggle(_a) {
    var _this = this;
    var className = _a.className, _b = _a.size, size = _b === void 0 ? 'md' : _b;
    var _c = useTheme(), theme = _c.theme, setTheme = _c.setTheme;
    var buttonRef = useRef(null);
    var handleToggle = function () { return __awaiter(_this, void 0, void 0, function () {
        var nextTheme, btn, supportsViewTransition, _a, left, top, width, height, cx, cy, vw, vh, xPct, yPct, radius, radiusBase, rPct, root, transition, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    nextTheme = theme === 'light' ? 'dark' : 'light';
                    btn = buttonRef.current;
                    supportsViewTransition = typeof document !== 'undefined' &&
                        'startViewTransition' in document &&
                        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                    if (!supportsViewTransition || !btn) {
                        setTheme(nextTheme);
                        return [2 /*return*/];
                    }
                    _a = btn.getBoundingClientRect(), left = _a.left, top = _a.top, width = _a.width, height = _a.height;
                    cx = left + width / 2;
                    cy = top + height / 2;
                    vw = window.innerWidth;
                    vh = window.innerHeight;
                    xPct = (cx / vw) * 100;
                    yPct = (cy / vh) * 100;
                    radius = Math.hypot(Math.max(cx, vw - cx), Math.max(cy, vh - cy));
                    radiusBase = Math.hypot(vw, vh) / Math.SQRT2;
                    rPct = (radius / radiusBase) * 100;
                    root = document.documentElement;
                    root.style.setProperty('--theme-x', "".concat(xPct, "%"));
                    root.style.setProperty('--theme-y', "".concat(yPct, "%"));
                    root.style.setProperty('--theme-r', "".concat(rPct, "%"));
                    root.classList.add('theme-circle-active');
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    transition = document.startViewTransition(function () {
                        flushSync(function () {
                            root.classList.toggle('dark', nextTheme === 'dark');
                            setTheme(nextTheme);
                        });
                    });
                    return [4 /*yield*/, transition.finished];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 3:
                    _b = _c.sent();
                    return [3 /*break*/, 5];
                case 4:
                    root.classList.remove('theme-circle-active');
                    root.style.removeProperty('--theme-x');
                    root.style.removeProperty('--theme-y');
                    root.style.removeProperty('--theme-r');
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("button", { ref: buttonRef, type: "button", onClick: handleToggle, className: cn('inline-flex items-center justify-center rounded-md transition-colors', 'text-foreground', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background', sizeMap[size], className), "aria-label": "Switch to ".concat(theme === 'light' ? 'dark' : 'light', " mode"), children: theme === 'light' ? (_jsx(Moon, { className: iconSizeMap[size] })) : (_jsx(Sun, { className: iconSizeMap[size] })) }));
}
